var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTiktok = function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m21.657 10.255 1.006.033V5.54l-.402-.029A5.74 5.74 0 0 1 16.972.388L16.932 0h-4.137l-.036 16.584c0 1.713-1.526 3.108-3.297 3.108a3.154 3.154 0 0 1 0-6.306c.079 0 .146.009.24.022l.143.018.485.059v-4.36l-.407-.026-.09-.006c-.111-.008-.243-.017-.371-.017a7.462 7.462 0 1 0 7.462 7.462V8.26a6.6 6.6 0 0 0 4.733 1.995"
  })));
};
export default SvgTiktok;